// extracted by mini-css-extract-plugin
module.exports = {"inputRoot":"DateRangeInput_inputRoot__3X3cQ","withMobileMargins":"DateRangeInput_withMobileMargins__39C6T","arrowIcon":"DateRangeInput_arrowIcon__1tFgx"};